const shimmer = `
  relative overflow-hidden
  before:absolute before:inset-0
  before:-translate-x-full
  before:animate-[shimmer_1.4s_infinite]
  before:bg-gradient-to-r
  before:from-transparent before:via-white/60 before:to-transparent
`

function SkeletonCard() {
  return (
    <div className="bg-white rounded-[20px] border-2 border-[#F2EDE4] overflow-hidden h-[300px]">
      {/* image area */}
      <div className={`h-40 bg-[#F2EDE4] ${shimmer}`} />
      {/* body */}
      <div className="px-4 pt-4 pb-4 flex flex-col gap-3">
        <div className={`h-4 w-3/4 rounded-full bg-[#F2EDE4] ${shimmer}`} />
        <div className={`h-3 w-full rounded-full bg-[#F2EDE4] ${shimmer}`} />
        <div className={`h-3 w-2/3 rounded-full bg-[#F2EDE4] ${shimmer}`} />
        <div className="flex items-center justify-between mt-1">
          <div className={`h-5 w-16 rounded-full bg-[#F2EDE4] ${shimmer}`} />
          <div className={`h-5 w-12 rounded-lg bg-[#F2EDE4] ${shimmer}`} />
        </div>
      </div>
    </div>
  )
}

export default function CatalogSkeleton() {
  //  Desktop: 1.5 rows x 4~ cols = 6 Cards
  //  Mobile: 2.5 rows x 1 col = 3 Cards
  //  Display 8 = the grid will be cut 
  //  according the real columns
  const cards = Array.from({ length: 8 })

  return (
    <div
      className="grid grid-cols-[repeat(auto-fill,minmax(240px,1fr))] gap-5 px-4 my-2 lg:my-2 py-2 lg:py-1"
      aria-busy="true"
      aria-label="טוען מוצרים"
    >
      {cards.map((_, i) => <SkeletonCard key={i} />)}
    </div>
  )
}